import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { Grid } from '@/models/Grid.model';
import {
  MESSAGES_ALL_OFFICE_LIST,
  MESSAGES_BY_CUSTOMER,
  MESSAGES_BY_CUSTOMER_ERRORS,
  MESSAGES_LOADING,
  OPEN_CREATE_MESSAGE_MODAL,
  OPEN_CREATE_MESSAGE_MODAL_ERRORS,
  OPEN_DELETE_MESSAGES_MODAL,
  OPEN_DELETE_MESSAGES_MODAL_ERRORS,
} from '@/types/backoffice/messages.types';
import { BackofficeMessageModel } from '@/models/BackofficeMessage.model';
import { MessagesState } from '@/store/modules/backoffice/messages/index';

export const getters: GetterTree<MessagesState, RootState> = {

  [MESSAGES_BY_CUSTOMER](state): Grid<BackofficeMessageModel> {
    return state.messagesByCustomer;
  },

  [MESSAGES_BY_CUSTOMER_ERRORS](state): string[] {
    return state.messagesByCustomerErrors;
  },

  [MESSAGES_LOADING](state): boolean {
    return state.messagesLoading;
  },

  [OPEN_CREATE_MESSAGE_MODAL](state): boolean {
    return state.openCreateMessageModal;
  },

  [OPEN_CREATE_MESSAGE_MODAL_ERRORS](state): string[] {
    return state.openCreateMessageModalErrors;
  },

  [OPEN_DELETE_MESSAGES_MODAL](state): boolean {
    return state.openDeleteMessagesModal;
  },

  [OPEN_DELETE_MESSAGES_MODAL_ERRORS](state): string[] {
    return state.openDeleteMessagesModalErrors;
  },

  [MESSAGES_ALL_OFFICE_LIST](state): Grid {
    return state.messagesAllOfficeList;
  },

  // [ALL_OFFICES_BY_CUSTOMER](state): Grid {
  //   return state.allOfficesByCustomer;
  // },
  //
  // [ALL_OFFICES_ERRORS](state): string[] {
  //   return state.allOfficesErrors;
  // },
  //
  // [OFFICE_DETAILS](state): CustomerDetailsModel {
  //   return state.officeDetails;
  // },
  //
  // [UPDATE_OFFICE_SETTINGS_MODAL](state): boolean {
  //   return state.updateOfficeSettingsModal;
  // },
  //
  // [UPDATE_OFFICE_SETTINGS_MODAL_ERRORS](state): string[] {
  //   return state.updateOfficeSettingsModalErrors;
  // },
  //
  // [ALL_REMINDERS_BY_CUSTOMER](state): Grid {
  //   return state.allRemindersByCustomer;
  // },
  //
  // [OPEN_CREATE_REMINDERS_MODAL](state): boolean {
  //   return state.openCreateRemindersModal;
  // },
  //
  // [OPEN_CREATE_REMINDERS_MODAL_ERRORS](state): string[] {
  //   return state.openCreateRemindersModalErrors;
  // },
  //
  // [MANAGERS_BY_CUSTOMER](state): Grid {
  //   return state.managersByCustomer;
  // },
  //
  // [MANAGER_TO_ADD](state): Grid {
  //   return state.managerToAdd;
  // },
  //
  // [MANAGER_TO_DELETE](state): ManagerPrivilegesModel | null {
  //   return state.managerToDelete;
  // },
  //
  // [OPEN_DELETE_MANAGER_MODAL](state): boolean {
  //   return state.openDeleteManagerModal;
  // },
  //
  // [OPEN_DELETE_MANAGER_MODAL_ERRORS](state): string[] {
  //   return state.openDeleteManagerModalErrors;
  // },
  //
  // [MANAGER_TO_UPDATE](state): ManagerPrivilegesModel | null {
  //   return state.managerToUpdate;
  // },
  //
  // [OPEN_UPDATE_MANAGER_MODAL](state): boolean {
  //   return state.openUpdateManagerModal;
  // },
  //
  // [OPEN_UPDATE_MANAGER_MODAL_ERRORS](state): string[] {
  //   return state.openUpdateManagerModalErrors;
  // },
  //
  // [OPEN_ADD_MANAGER_MODAL](state): boolean {
  //   return state.openAddManagerModal;
  // },
  //
  // [OPEN_ADD_MANAGER_MODAL_ERRORS](state): string[] {
  //   return state.openAddManagerModalErrors;
  // },
  //
  // [ORG_UNITS](state): OrganisationUnitModel[] {
  //   return state.orgUnits;
  // },
  //
  // [MANAGER_PRIVILEGES](state): any {
  //   return state.managerPrivileges;
  // },

};
